import React from 'react';

import type { Meta } from '@swf/generated/cms/types/Meta';

import sharedStyles from '../../styles/styles.scss';
import CMSLink from '../CMSLink/CMSLink';

import styles from './CMSBanner.scss';

const CMSBanner: React.FC<Meta['banner']> = ({ variant, linked_image: linkedImage }) => {
  if (!linkedImage.image.asset) {
    return null;
  }

  const imgContainer = (
    <div
      style={{ backgroundImage: `url(${linkedImage.image.asset.url})` }}
      className={styles.banner}
    />
  );

  return (
    <div className={sharedStyles[variant ?? '']}>
      {linkedImage.link.url ? (
        <CMSLink title="" {...linkedImage.link}>
          {imgContainer}
        </CMSLink>
      ) : (
        imgContainer
      )}
    </div>
  );
};

export default CMSBanner;
